import { Component, OnInit, Pipe } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultsService } from '../../../services/results.service';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.css']
})
// @Pipe({name: 'safeHtml'})
export class AccessibilityComponent implements OnInit {
  content: string = "Your Accessibility Content Here";
  fileName: string = "Accessibility";
  interval:any;
  constructor(private resultservice: ResultsService) {
  }

  ngOnInit() {
    this.GetDefaultPrefernces();
    this.interval = setInterval(() => { 
        this.GetDefaultPrefernces(); 
    }, 10000);
  }

  GetDefaultPrefernces() {
    this.resultservice.getAllPreferences(this.fileName).then((result: any) => {
      if (result != null && result != '' && result != undefined) {
        this.content = result.content;
      }
    });
  }
}
